<template>
  <form @submit.prevent @keyup.enter.stop="searchSocio" action="">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">Buscar Sócio no Banco de Dados</p>
      </header>

      <section class="modal-card-body">
        <div v-if="!ativeLoader">
          <div class="field">
            <label class="label">Insira o CPF do Sócio</label>
          </div>
          <div class="field has-addons">
            <div class="control">
              <input
                class="input"
                type="text"
                placeholder="000.000.000-00"
                v-model="cpf"
                v-mask="'###.###.###-##'"
              >
            </div>
            <div class="control">
              <a class="button is-info" @click="searchSocio">Buscar</a>
            </div>
          </div>
        </div>

        <div v-if="ativeLoader" class="loading">
          <div class="loading-animation">
            <lottie :options="defaultOptions" :height="100" :width="100"/>
          </div>
          <p>Aguarde um instante...</p>
        </div>

        <div v-if="socioFound" class="socio-found">
          <div class="card" style="width: 320px; margin: 20px auto 0 auto">
            <header class="card-header">
              <p class="card-header-title" style="justify-content: center;">Informações do Sócio</p>
            </header>
            <div class="card-image" style="padding: 10px;">
              <div class="content">
                <p>
                  <strong>Nome:</strong>
                  {{this.$store.getters["associados/getSocio"].nome}}
                </p>
                <p>
                  <strong>Profissão:</strong>
                  {{this.$store.getters["associados/getSocio"].profissao_atual}}
                </p>
                <p>
                  <strong>Situação:</strong>
                  {{statusSocio}}
                </p>
              </div>
            </div>
            <footer class="card-footer">
              <p v-if="isActive" class="card-footer-item">Já é Membro da Associação</p>
              <a v-else-if="isArchive" href="#" @click="unarchiveSocio" class="card-footer-item button is-danger">Desarquivar</a>
              <a v-else href="#" class="card-footer-item button is-primary" @click="openAddExistentSocioModal">Editar e Adicionar</a>
            </footer>
          </div>
        </div>

        <div v-if="socioNotFound" class="socio-not-found">
          <div class="card" style="width: 320px; margin: 20px auto 0 auto">
            <header class="card-header">
              <p class="card-header-title" style="justify-content: center;">Sócio não Encontrado</p>
            </header>
            <footer class="card-footer">
              <a href="#" class="card-footer-item button is-success" @click="openFormAddSocioModal">Cadastrar Associado</a>
            </footer>
          </div>
        </div>
      </section>

      <footer class="modal-card-foot">
        <button class="btn-cancel button is-danger is-small" @click="closeModal">Cancelar</button>
      </footer>
    </div>
  </form>
</template>

<script>
import Lottie from "vue-lottie";
import * as animationData from "@/assets/loading-animation.json";
import FormAddSocios from "./FormAddSocios";
import AddExistentSocioModal from "./AddExistentSocioModal"

export default {
  components: {
    lottie: Lottie
  },
  data() {
    return {
      defaultOptions: { animationData: animationData.default },
      cpf: "",
      socioFound: false,
      socioNotFound: false,
      statusSocio: "Não Cadastrado",
      isActive: false,
      isArchive: false,
      ativeLoader: false
    };
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },

    // Busca o sócio no banco de dados
    async searchSocio() {
      let error = this.validateCPF();
      this.socioNotFound = this.socioFound = false;

      if (error) {
        this.$alert("Aviso!", error, "danger");
        return;
      }
      this.ativeLoader = true;
      await this.$store.dispatch(
        "associados/getSocioInFirestore",
        this.cpf.replace(/\D+/g, "")
      );

      if (this.$store.getters["associados/getSocio"]) {
        this.$alert("Aviso!", "Sócio Encontrado!", "info");
        this.verifyStatusSocio();
        this.socioFound = true;
      } else {
        this.$alert("Aviso!", "Sócio não Encontrado!", "grey");
        this.socioNotFound = true;
      }
      this.ativeLoader = false;
    },

    // Verifica se o sócio está ativo ou arquivado ou não é cadastrado na associação
    verifyStatusSocio() {
      let idSocio = this.$store.getters["associados/getSocio"]._id;
      this.isActive = this.isArchive = false;

      let isActive = this.$store.getters[
        "associacao/getAssociacao"
      ].socios.ativos.filter(data => {
        return data._id == idSocio;
      });

      if (isActive.length != 0) {
        this.statusSocio = "Sócio Ativo";
        this.isActive = true;
        return;
      }

      let isArchive = this.$store.getters[
        "associacao/getAssociacao"
      ].socios.arquivados.filter(data => {
        return data._id == idSocio;
      });

      if (isArchive.length != 0) {
        this.statusSocio = "Sócio Arquivado";
        this.isArchive = true;
        return;
      }
    },

    validateCPF() {
      let strCPF = this.cpf.replace(/\D+/g, "");
      let soma = 0;
      let resto;

      if (!strCPF.trim()) return "Insira um Número de CPF!";
      if (strCPF == "00000000000") return "Insira um CPF Válido!";

      for (let i = 1; i <= 9; i++)
        soma = soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
      resto = (soma * 10) % 11;

      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(strCPF.substring(9, 10)))
        return "Insira um CPF Válido!";

      soma = 0;
      for (let i = 1; i <= 10; i++)
        soma = soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
      resto = (soma * 10) % 11;

      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(strCPF.substring(10, 11)))
        return "Insira um CPF Válido!";
      return;
    },

    async unarchiveSocio() {
      this.ativeLoader = true;
      this.socioFound = false;

      await this.$store.dispatch(
        "associacao/unarchivePartnerInFirestore",
        this.$store.getters["associados/getSocio"]._id
      );

      if (this.$store.getters["associacao/getIsSuccess"]) {
        this.$alert("Aviso!", "Sócio Desarquivado!", "success");
        this.closeModal();
      } else {
        this.$alert("Aviso!", "Erro ao desarquivar Sócio!", "danger");
        this.socioFound = true;
      }

      this.ativeLoader = false;
    },

    openFormAddSocioModal() {
      this.$modal.open({
        parent: this,
        component: FormAddSocios,
        hasModalCard: true,
        canCancel: false,
        props: {
          cpf: this.cpf
        }
      });
      this.closeModal();
    },

    openAddExistentSocioModal(socio) {
      this.$modal.open({
        parent: this,
        component: AddExistentSocioModal,
        hasModalCard: true,
        props: {
          associado: this.$store.getters["associados/getSocio"]
        }
      });
      this.closeModal();
    }
  },
  mounted() {}
};
</script>

<style scoped>
.button:not(.btn-cancel) {
  height: 2.6em !important;
}
.loading {
  text-align: center;
}
p {
  margin: 0 !important;
}
footer {
  text-align: right;
  display: block;
}
@media screen and (max-width: 1088px) {
  .modal .animation-content .modal-card {
    overflow: scroll !important;
  }
}
</style>
